import {useDispatch, useSelector} from "react-redux";
import InputComponent from "../../../components/input.component";
import React from "react";
import {setAvoskinTrailRunAboutDetail} from "../../../reducers/avoksin-trail-run.reducer";
import InputImage from "./input-image";

const InputField = ({fieldList}) => {
    const dispatch = useDispatch()
    const {aboutAvoskinTrailRunDetail, avoskinTrailRunErrorMessage} = useSelector(state => state.avoskinTrailRunReducer)

    const onChangeInput = (key, value) => {
        dispatch(setAvoskinTrailRunAboutDetail({[key]: value}))
    }

    return (
        <div className={"grid grid-cols-2 gap-x-16 gap-y-4"}>
            {fieldList.map((item, index) => (
                <div key={index} className={item.key === 'slider_images' ? 'col-span-2' : ''}>
                    {
                        item.key === 'slider_images' ?
                            <InputImage fieldList={item}/>
                            :
                            <InputComponent data={aboutAvoskinTrailRunDetail[item.key]} item={item}
                                            onChange={onChangeInput} onChangeInput={onChangeInput}
                                            error={avoskinTrailRunErrorMessage}/>
                    }
                </div>
            ))}
        </div>
    )
}

export default InputField
